module.exports = __webpack_public_path__ + "static/media/om_hairstyle_suave_front_shadow.50cc77fa.png";